export default __webpack_public_path__ + "static/media/permissions.29378a65.png";